import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { message } from 'antd';
import Filter from './components/Filter';
import List from './components/List';
import Attachment from './components/Attachment';
import Update from './components/Update';
import ExportUtil from '../../../common/ExportUtil';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import SideNav from '../SideNav';
import { saveParams } from '../../../actions/noticeActions';
import './style.less'

class NationalVerification extends Component {

    constructor(props) {
        super(props);
        const { params } = props;
        const { nationVerifyNumber } = params;
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
            },
            searchParams: { nationVerifyNumber, },
            sortParams:{},
            data: [],
            business: [],
            area: [],
            loading: false,
            type: undefined,
            record: {},
        };
    }

    componentDidMount() {
        this.queryWithLevelByParams();
        this.queryVerificationInstitutions();
        this.queryArea();
        this.loadData();
    }

    componentWillUnmount() {
        this.props.saveParams({ investigationName: undefined, nationVerifyNumber: undefined });
    }

    queryVerificationInstitutions = () => {
        dictCache.getDict('NATION_VERIFY_CONFIG', cb => {
            Fetch.post(API_URL.nationalverification.queryConfigureList).then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            const {verifyAgencyList} = res;
            this.setState({verifyAgencyList})
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, {
                typeName: 'LINE_OF_BUSINESS'
            }).then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            this.setState({ business: res.typeConfigureList || [] });
        });
    }

    queryArea = () => {
        dictCache.getDict('AREA_ALL', cb => {
            Fetch.post(API_URL.common.queryAllInvestigationArea)
            .then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            this.setState({ area: res.data });
        });
    }

    loadData = () => {
        const { pagination, searchParams ,sortParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        Fetch.post(API_URL.nationalverification.queryNationVerifyList, {
            offset: current,
            limit: pageSize,
            ...searchParams,
            ...sortParams,
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                data: datas,
                pagination,
                loading: false,
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    handleSearch = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    handleReset = () =>{
        this.setState({ searchParams:{} }, () => {
            this.loadData();
        });
    }

    handleExport = () => {
        const { pagination, searchParams } = this.state;
        ExportUtil.export(searchParams, pagination, API_URL.nationalverification.exportNationVerifyList);
        message.success('国家核查汇总开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出')
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    update = (type, record) => {
        this.setState({
            type,
            record,
        }, () => {
            !type && this.loadData();
        });
    }

    remove = (nationVerifyId) => {
        this.setState({ loading: true });
        Fetch.post(API_URL.nationalverification.delNationVerify, {
            nationVerifyId,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({ loading: false }, () => {
                this.loadData();
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    download = (nationVerifyId) => {
        ExportUtil.export({ nationVerifyId }, null, API_URL.qualityManagement.exportComplaintRecordWord);
    }

    showAttac = (record) => {
        this.attacRef.show(record);
    }
    
    showUpdate = (modelType , record) => {
        this.updateRef.show(modelType ,record);
    }

    render() {
        const { business, area, searchParams, data, loading, pagination ,verifyAgencyList ,sortParams} = this.state;
        return (
            <div className="content">
                <SideNav selectKey="nationalVerification" />
                    <div className="main">
                        <Filter
                            area={area}
                            business={business}
                            searchParams={searchParams}
                            update={this.update}
                            onSearch={this.handleSearch}
                            onExport={this.handleExport}
                            onChange={this.handleFilterChange}
                            onReset={this.handleReset}
                            showUpdate={this.showUpdate}
                            verifyAgencyList={verifyAgencyList}
                        />
                        <List
                            data={data}
                            loading={loading}
                            pagination={pagination}
                            sortParams={sortParams}
                            update={this.update}
                            remove={this.remove}
                            download={this.download}
                            onChange={this.handleTableChange}
                            showAttac={this.showAttac}
                            showUpdate={this.showUpdate}
                        />
                    </div>
                <Attachment ref={el => this.attacRef = el} />
                <Update ref={el => this.updateRef = el} loadData={this.loadData}/>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NationalVerification);


// WEBPACK FOOTER //
// ./src/components/qualityManagement/Nationalverification/index.js